import { get } from './request';
import { IAgentPromptLogData } from 'types/agentPromptLog';

export interface IGetAgentPromptLogParams {
  entity_type: string;
  entity_id: number;
}

export interface IAgentPromptLogResponse {
  data: IAgentPromptLogData[];
  error: string | null;
}

export const getAgentPromptLogByEntity = async (
  params: IGetAgentPromptLogParams
): Promise<{ data: IAgentPromptLogData[]; error: string | null }> => {
  try {
    const response = await get<IAgentPromptLogResponse>('/agent-prompt-log/by-entity', params);
    return {
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('Failed to fetch agent prompt log:', error);
    return {
      data: [],
      error: 'Failed to fetch agent prompt log'
    };
  }
};
